import { Dialog, DialogBody, DialogContent, DialogSurface, DialogTitle } from '@fluentui/react-components';

export const OfferPdfPreview = ({ open, html, onOpenChange }: { open: boolean; html: string; onOpenChange: (open: boolean) => void }) => (
  <Dialog open={open} onOpenChange={(_, data) => onOpenChange(data.open)}>
    <DialogSurface style={{ maxWidth: '210mm', width: '210mm', maxHeight: '90vh' }}>
      <DialogBody>
        <DialogTitle>Aperçu du devis</DialogTitle>
        <DialogContent>
          <iframe title="Offer preview" srcDoc={html} style={{ width: '100%', height: '297mm', maxHeight: '75vh', border: '1px solid #eee', borderRadius: 4 }} />
        </DialogContent>
      </DialogBody>
    </DialogSurface>
  </Dialog>
);
